<template>
  <div>

    <Window ref="Window" :bg="Boolean(true)" @Close="myClose">
      <!-- 头部开始 -->
      <div slot="headButton"
           class="dpIB fSub_E hover-f-main_E tra-fast_E">
        <button @click="refresh" :title="$t('cmd7',['刷新'])" type="button">
          <Icon name="refresh" class="w1x h1x" :sizeBase="'m'" /></button>
      </div>
      <div slot="head" class="cb">
        <div class="">
          <div>
            <div class="dpIB vaM fs14x">{{getTypeText(deviceDetail.type||'','deviceType')+':'}}{{deviceDetail.deviceSn}}</div>
          </div>
          <div class="posR mt1x">
            <div class="dpIB_E dpIB fs12x">
              <div class="mr1x">
                <span v-if="deviceDetail.deviceState==null">--</span>
                <StatusIco v-else
                           :id="deviceDetail.deviceState"
                           :type="'device'"
                           class="statueIcon fs08x"></StatusIco>
                <span v-if="deviceDetail.deviceState!=null">
                  {{getTypeText(deviceDetail.deviceState,'deviceState')}}
                </span>
              </div>
              <!-- <div class="mr1x">
								<span v-if="deviceDetail.alertStatus==null">--</span>
								<StatusIco v-else :id="deviceDetail.alertStatus" :type="'deviceAlarm'" class="statueIcon fs08x"></StatusIco>
								<span v-if="deviceDetail.alertStatus!=null">
									{{[-1].includes(deviceDetail.alertStatus)?getLanguageStr('word1465','无报警'):getLanguageStr('word1464','有报警')}}
								</span>
							</div> -->
            </div>
            <div class="fR">
              <span v-if="deviceDetail.collectionTime">{{timeFormat(deviceDetail.collectionTime,'utc','%Y/%m/%d %H:%M UTC',{offset:deviceDetail.timeZone})}}</span>
              <!--<span v-if="data.dataUpdateTime !=null">{{data.dataUpdateTime|time('%Y/%m/%d %H:%M','utc')}}</span><span v-else>--</span>-->
            </div>
          </div>
        </div>
      </div>
      <!-- 头部结束end -->

      <div fillheight="lastHeight" scroll class="upgradedevice pl1x pt1x pr1x pb1x">
        <div class="device-info panel bgPanel pt1x cb pr1x pl1x pb1x borderbox mb1x">
          <section class="fs12x lh15">
            <span>{{getLanguageStr('device_management35','当前版本信息')}}</span>
          </section>
          <Loading></Loading>
          <no-result v-show="!curDeviceVersion.length"></no-result>
          <section class="tableSys pt1x pl1x pr1x"
                   v-for="dv in curDeviceVersion">
            <div v-for="item in dv"
                 class="pt05x pb05x"><span class="cSub">{{item.name}}：</span>{{item.version}}</div>
          </section>
        </div>

        <div class="last-order-record panel bgPanel pt1x cb pr1x pl1x pb1x borderbox mb1x">
          <section class="fs12x lh15">
            <span>{{getLanguageStr('word1509','最近一条升级记录')}}</span>
            <div class="fR"
                 @click="showOrderRecord"
                 v-show="lastOrderInfo">
              <span class="icoSys h2x w2x curP dpB">
                <svg class="ico fSub">
                  <use xlink:href="#more"></use>
                </svg>
              </span>
            </div>
          </section>
          <Loading></Loading>
          <no-result v-show="!lastOrderInfo"></no-result>
          <div class="result lh13"
               v-show="lastOrderInfo">
            <section class="tableSys pt1x pl1x pr2x_E vaT_E">
              <div class="pt05x pb05x"><div class="cSub mb05x">{{getLanguageStr('word1510','目标版本号')}}：</div>{{lastOrderInfo.version}}</div>
              <div class="pt05x pb05x"><div class="cSub mb05x">{{getLanguageStr('device223','关联版本信息')}}：</div>{{lastOrderInfo.versionKeyName}}</div>
              <div class="pt05x pb05x"><div class="cSub mb05x">{{getLanguageStr('word1512','升级时间')}}：</div>{{timeFormat(lastOrderInfo.createTime/1000,'inc','%Y/%m/%d %H:%M:%S UTC')}}</div>
            </section>
            <section class="tableSys pt1x pl1x pr2x_E vaT_E">
              <div class="pt05x pb05x vaM_E">
                <div class="mb05x cSub vaM_E">{{getLanguageStr('word1513','升级状态')}}：</div>
                <div class="progressbar mr05x fMain vaM taC"
                      v-if="lastOrderInfo.status==100||lastOrderInfo.status==300">
                  <div class="w30pct vaM dpIB">
                    <div class="probody bgProgress">
                      <div class="probody leftFill  bgBlue progressMove"></div>
                    </div>
                  </div>
                </div>
                <div class="vaM_E cBlueLight"
                      v-if="lastOrderInfo.status==100||lastOrderInfo.status==300">
                  {{getLanguageStr('plant_control1','升级中')}}
                </div>
                <div class="dpIB vaM_E cGreenLight"
                      v-if="lastOrderInfo.status==666">
                  <div class="dpIB fWhite">
                    <div class="icoSys dvStatus bgSuccess">
                      <Icon name="yes" />
                    </div>
                  </div>
			           <div class="dpIB">{{getLanguageStr('word201','已成功')}}</div>
                </div>
                <div class="dpIB vaM_E cWarning"
                      v-if="lastOrderInfo.status==500">
                  <div class="dpIB fWhite">
                    <div class="icoSys dvStatus bgWarning">
                      <Icon name="no" />
                    </div>
                  </div>
                  <div class="dpIB">{{getLanguageStr('word202','失败')}}</div>
                  <span class='pl2x cMain curP'
                        @click='resend'>{{getLanguageStr('cmd77','重试')}}</span>
                </div>
              </div>
              <div class="pt05x pb05x"
                   v-if="lastOrderInfo.status!=100&&lastOrderInfo.status!=300"><div class="cSub mb05x">{{getLanguageStr('plant56','反馈时间')}}：</div>{{timeFormat(lastOrderInfo.updateTime/1000,'inc','%Y/%m/%d %H:%M:%S UTC')}}</div>
              <div class="pt05x pb05x"></div>
            </section>
          </div>
        </div>

        <div class="panel bgPanel pt1x cb pr1x pl1x pb1x borderbox mb1x lh13">
          <section class="fs12x lh15">
            <span class="">{{getLanguageStr('cmd32','选择固件包')}}</span>
          </section>
          <section class="tableSys pt1x pl1x pr2x_E vaT_E">
            <div class="pt05x pb05x vaM_E">
              <div class="cSub">{{getLanguageStr('device_management101','固件包名称')}}：</div>
              <solar-select :name="'orderName'" class="mt05x"
                            :search="{key:'name',placeholder:getLanguageStr('device_management101','固件包名称')}"
                            v-model="curFirmwareId"
                            :bindActive="curFirmwareId"
                            @Click="getFirmDetail"
                            :list="firmwareList"
                            :keyMap="{text:'name',value:'id'}"
                            bindMode="target"></solar-select>
            </div>
            <div class="pt05x pb05x vaM_E"
                 v-if="curFirmwareInfo.orderFirmwarePackage">
              <div class="cSub">{{getLanguageStr('device127','固件版本号')}}：</div>
              <div class="mt05x">{{curFirmwareInfo.orderFirmwarePackage.version||''}}</div>
            </div>
            <div class="pt05x pb05x vaM_E"
                 v-if="curFirmwareInfo.orderFirmwarePackage">
              <div class="cSub">{{getLanguageStr('word1514','适用型号')}}：</div>
              <div class="mt05x">{{curFirmwareInfo.orderFirmwarePackage.matchModel||'--'}}</div>
            </div>
          </section>
          <section class="tableSys pt1x pl1x pr2x_E vaT_E"
                   v-if="curFirmwareInfo.orderFirmwarePackage">
            <div class="pt05x pb05x vaM_E">
              <div class="cSub">{{getLanguageStr('word1515','可升级软件版本号')}}：</div>
              <div class="mt05x">{{curFirmwareInfo.orderFirmwarePackage.matchFirmwareVersion||'--'}}</div>
            </div>
            <div class="pt05x pb05x vaM_E">
              <div class="cSub">{{getLanguageStr('word1504','适用硬件版本号')}}：</div>
              <div class="mt05x">{{curFirmwareInfo.orderFirmwarePackage.matchHardwareVersion||'--'}}</div>
            </div>
            <div class="pt05x pb05x vaM_E">
            </div>
          </section>
          <section class="tableSys pt1x pl1x pr1x"
                   v-if="curFirmwareInfo.orderFirmwarePackage">
            <div class="pt05x pb05x vaM_E vaM_EE taR">
              <div class="dpIB pr2x"
                   v-show='showSim'><span class='cSub'>{{getLanguageStr('升级通道','升级通道')}}：</span>
                <solar-select :name="'orderName'"
                              v-model="channel"
                              :bindActive="channel"
                              @Click="getchannel"
                              :list="channelList"
                              :keyMap="{text:'name',value:'id'}"
                              bindMode="target"></solar-select>
              </div>
              <div class="dpIB pr2x">
                <span class="cSub">{{getLanguageStr('word1507','超时时间')}}：</span>
                <input-text class="w3x dpIB ml05x mr05x"
                            v-model="orderTimeout"
                            :max-length="2"
                            only="absInt"
                            :verification="'notEmpty,~:10~60'"></input-text>
                <span class="cSub">{{getLanguageStr('unit54','分钟')}}</span>
                <Help :code="'orderUpgrad'"
                      :btnClose="false"
                      class="vaM ml1x"></Help>
              </div>
              <button :class="{'disable':lastOrderInfo.status=='100'||hasClick||lastOrderInfo.status=='300'}"
                      class="functionBtn bgMain"
                      type="button"
                      onclick="statistic('A70','A7002')"
                      @click="sendOrder">{{getLanguageStr('cmd21','固件升级')}}</button>
            </div>
          </section>
        </div>
      </div>

    </Window>
    <!--  <ViewDetail ref="ViewDetail" :bg="Boolean(true)"  @Close='deviceUpdateClose'></ViewDetail>-->
  </div>
</template>

<script>
import * as lib from '@/util/lib'
import { getLanguageStr } from '@/util/language'
import { mapGetters, mapActions, mapMutations } from 'vuex'

import Window from '@/components/common/ui/WindowForView.vue'
import StatusIco from '@/components/common/ui/StatusIco'
import SolarSelect from '@/components/common/ui/Select.vue'
import Loading from '@/components/common/ui/Loading'
import NoResult from '@/components/common/ui/NoResult'
import InputText from '@/components/common/ui/InputText.vue'
import DeviceDetail from '@/view/device/operationalAudit/ViewDetail.vue'
import Help from '@/components/common/Help.vue'

import { orderUpgradControlSend, orderActionLast, orderListCode, deviceOrderVersion, simOrder, uResend } from '@/api/device/order'
import { orderFirmwareListCode, GetFirmDetail } from '@/api/device/firmware'
import { getDeviceDetail } from '@/api/device/list'

export default {
  name: 'DeviceUpgrade',
  components: { SolarSelect, Window, StatusIco, Loading, NoResult, InputText, Help },
  props: {
    deviceType: {
      type: [Number, String],
      default: 2
    }
  },
  data () {
    return {
      id: 'DeviceUpgrade',
      device: {},
      channel: '',
      channelList: lib.getTypeText('', 'channelList', true),
      firmwareList: [],
      curFirmwareId: null,
      curFirmwareInfo: {},
      lastOrderInfo: {},
      orderInterval: null,
      deviceDetail: {},
      curDeviceVersion: [], // 当前版本信息
      orderTimeout: 40,
      hasClick: false,
      showSim: false
    }
  },
  watch: {
    showSim: function (v) {
      if (v) {
        this.channel = 1
      } else {
        this.channel = ''
      }
    }
  },
  methods: {
    ...mapMutations({
      SET_CURRENTINDEX: 'deviceDetail/SET_CURRENTINDEX'
    }),
    getLanguageStr,
    timeFormat: lib.timeFormat,
    getTypeText: lib.getTypeText,
    resend () {
      // console.log(this.lastOrderInfo.orderId)
      uResend(this.lastOrderInfo.orderId, { timeoutSeconds: 2400 }).then(() => {
        this.refresh()
      })
    },
    getchannel () {

    },
    myClose () {
       if (this.orderInterval) clearInterval(this.orderInterval)// 清楚定时器。
      if (this.instance) {
        setTimeout(() => {
          this.instance.destroyUi()
        }, 500)
      }
    },
    showOrderRecord () {
      //			//打开指令记录
      //			this.$refs.Window.hide()
      //			this.$emit('showOrderRecord',this.device);
      // this.$bus.$emit('openViewdetail', this.device, 'OperateRecord', this.deviceType, 2, false, this.$el)
      // this.$refs.ViewDetail.show(this.device, 'OperateRecord', '', this.deviceType, 2, false)

      	this.$dynamic($(this.$el).parents("#app").find(".frame-main section").first()[0],DeviceDetail,{bg:true},{
				'closePage': [],
				'refresh': [],
				'update': [],
				'showStations': [],
				'DeviceControls': [],
				'DeviceUpgrades': [],
				'Dels': []
			},{}).then(({ instance, childInstance }) => {
				childInstance.show(this.device, 'OperateRecord', instance, this.deviceType, 2, false);
				// else this.$notify(getLanguageStr('device25','设备还没有数据上传记录，请确认上电并成功连接服务器后重试。'));
			});
    },
    refresh () {
      lib.loadingChange($('.device-info [loading]'), 'true')
      this.getDeviceInfo()// 设备详情
      lib.loadingChange($('.last-order-record [loading]'), 'true')
      // this.getListCode()
      this.lastOrder()
      this.getCurVerInfo()
      this.curFirmwareInfo = {}
      this.curFirmwareId = ''
      this.hasClick = false
    },
    deviceUpdateClose () {
      if (this.orderInterval) clearInterval(this.orderInterval)// 清楚定时器。
    },
    show (device, firmwareList, instance) {
      if (instance) {
        this.instance = instance
      }
     
      this.$refs.Window.show({end:()=>{
      
        this.device = device
        this.getListCode(firmwareList)
        this.orderTimeout = 40
        // this.getCurVerInfo()
        
        lib.loadingChange($('.device-info [loading]'), 'true')
        this.getDeviceInfo()// 设备详情
        lib.loadingChange($('.last-order-record [loading]'), 'true')
        this.lastOrder()
        this.getCurVerInfo()
        simOrder(device.deviceId, { product: device.productId, gatewayId: device.parDeviceId }).then(data => {
          this.showSim = data
          if (this.showSim) {
            this.channel = 1
          } else {
            this.channel = ''
          }
        })
    
      }})
      
      
    },
    async getDeviceInfo () {
      await getDeviceDetail({
        'siteId': this.device.siteId,
        'deviceId': this.device.deviceId,
        'language': stage.languageId == '1' ? 'zh' : 'en',
        'needRealTimeDataFlag': true,
        'tag': 'version'
      }).then(res => {
        // if (res) res.collectionTime = Number(res.collectionTime) + mz.tz(res.timeZone)._offset * 60
        this.deviceDetail = res
        this.$refs.Window.loadStatusAction(false)
        //				if(res && res.paramCategoryList && res.paramCategoryList[0] && res.paramCategoryList[0].fieldList){
        //					let iA = [];
        //					this.curDeviceVersion= [];
        //					res.paramCategoryList[0].fieldList.map((f,i)=>{
        //						if(i%3==0) iA =[];
        //						iA.push(f);
        //						if(i%3==2 || res.paramCategoryList[0].fieldList.length == (i+1)) this.curDeviceVersion.push(iA);
        //					})
        //				}
        lib.loadingChange($('.device-info [loading]'), 'false')
      }, error => {
        lib.loadingChange($('.device-info [loading]'), 'false')
        this.$refs.Window.loadStatusAction(false)
        !_.isEmpty(error) && this.$notify(error)
        return false
      })
    },
    async getListCode (data) {
      if (data) {
        this.firmwareList = [{ name: getLanguageStr('phrase666', '请选择固件名称'), id: '',token:true}]
        data.map((item, index) => {
          item.value = item.id
          return item
        })
        this.curFirmwareId = ''
        this.curFirmwareInfo = {}
        this.firmwareList = this.firmwareList.concat(data)
      } else {
        await orderFirmwareListCode(this.device.productId).then(res => {
          this.firmwareList = [{ name: getLanguageStr('phrase666', '请选择固件名称'), id: '',token:true}]
          data.map((item, index) => {
            item.value = item.id
            return item
          })
          this.curFirmwareId = ''
          this.curFirmwareInfo = {}
          this.firmwareList = this.firmwareList.concat(data)
          return true
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
          return false
        })
      }
    },
    getFirmDetail () {
      if (this.curFirmwareId) {
        let language = stage.languageId
        GetFirmDetail(this.curFirmwareId, language).then(res => {
          this.curFirmwareInfo = res
        }, error => {
          !_.isEmpty(error) && this.$notify(error)
          return false
        })
      } else {
        this.curFirmwareInfo = {}
      }
    },
    async getCurVerInfo () {
      let param = {
        productKey: this.device.productId,
        language: stage.languageId
      }
      await deviceOrderVersion(this.device.deviceId, param).then(res => {
        if (res) {
          this.curDeviceVersion = []
          for (var i = 0; i < res.length; i += 3) {
            this.curDeviceVersion.push(res.slice(i, i + 3))
          }
        }
      }, error => {
        !_.isEmpty(error) && this.$notify(error)
        return false
      })
    },
    async lastOrder () { // 查询结果
      try {
        let result = await orderActionLast({
          deviceId: this.device.deviceId,
          // deviceType: this.deviceType,
          orderType: 2, // 指令类型(1.控制指令 2.升级指令)
          language: stage.languageId
        })
        // if (result.createTime) result.createTime += mz.tz(this.device.timezone)._offset * 60 * 1000
        // if (result.updateTime) result.updateTime += mz.tz(this.device.timezone)._offset * 60 * 1000
        this.lastOrderInfo = result
        lib.loadingChange($('.last-order-record [loading]'), 'false')

        if (this.orderInterval) clearInterval(this.orderInterval)
        if (result.status == 100 || result.status == 300) { // 指令发送中，禁止点击
          this.orderInterval = setInterval(() => { // 失败情况继续查询状态
            this.lastOrder()
            this.getCurVerInfo()
          }, 10000)
        }

        return result
      } catch (error) {
        !_.isEmpty(error) && this.$notify(error)
        lib.loadingChange($('.last-order-record [loading]'), 'false')
        return false
      }
    },
    paramCheck () {
      let cr = true
      if (this.curFirmwareId == '') {
        // TODO
        this.$notify(getLanguageStr('phrase666', '请选择固件名称'))
        cr = false
      } else if (cr && Number(this.orderTimeout) == 0) {
        this.$notify(getLanguageStr('phrase847', '请输入超时时间'))
        cr = false
      }
      return cr
    },
    async sendOrder () {
      if (this.orderTimeout < 10 || this.orderTimeout > 60) {
        return false
      }
      if (this.hasClick) {
        return false
      }
      this.hasClick = true
      if (this.paramCheck()) {
        let req = {
          'deviceId': this.device.deviceId,
          'deviceSn': this.device.deviceSn,
          // 'deviceType': this.deviceType, // 1:采集器 2:普通设备
          'firmwareId': this.curFirmwareId,
          'gatewayId': this.device.parDeviceId,
          'gatewaySn': this.device.parDeviceSn,
          'orderTimeout': this.orderTimeout * 60, // 指令超时时间 单位秒
          'product': this.device.productId,
          channel: this.channel[0]
          // 'sensor': this.device.sensor
        }
        try {
          await orderUpgradControlSend(req)
          // await new Promise((re, rj) => {
          //   setTimeout(_ => {
          //     re()
          //   }, 5000)
          // })
          setTimeout(() => {
            this.hasClick = false
          }, 500)

          this.refresh()
          this.isSending = false
        } catch (error) {
          !_.isEmpty(error) && this.$notify(error)
          this.isSending = false
          this.hasClick = false
        }
      }
    }
  },
  mounted () {
    setTimeout(() => {
      lib.fillHeight()
		  lib.setScroll($(this.$el).find('[scroll]'))
    }, 10);
    
  }
}
</script>

<style lang="scss" scoped>
.window > .body {
  padding-bottom: 0;
}
.head {
  background: #fff;
}
.statueIcon {
  vertical-align: middle;
  margin: -3px 5px 0 0;
}
.statueIcon /deep/ .dvStatus {
  width: 1.2em;
  height: 1.2em;
}
button::-moz-focus-inner {
  border: 0;
}
.dropList {
  background: #fff;
  width: 9em;
  left: -2em;
  a {
    color: #666;
    padding-right: 1em;
  }
  a:hover {
    background-color: rgba(0, 0, 0, 0.05);
    color: #ff595f;
  }
}
.pd0 {
  padding: 0 !important;
}

.borderbox {
  box-sizing: border-box;
}

.progressbar {
  .probody {
    height: 10px;
    border-radius: 5px;
    margin-right: -5px;
  }
  .bgProgress {
    background-color: #a3d8ff;
  }
  .leftFill {
    margin-right: 0;
    width: 0;
  }
  .rightFill {
    margin-left: 0;
    width: 0;
  }
  .progressMove {
    animation: promove 5s;
    -webkit-animation: promove 5s infinite;
    -moz-animation: promove 5s infinite;
    animation-iteration-count: infinite;
    -webkit-animation-iteration-count: infinite;
    -moz-animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;
    -moz-animation-fill-mode: forwards;
  }
  @keyframes promove {
    0% {width: 0px;}
    50% {width: 50%;}
    100% {width: 100%;}
  }
  @-webkit-keyframes promove {
    0% {width: 0px;}
    50% {width: 50%;}
    100% {width: 100%;}
  }
}
</style>



// WEBPACK FOOTER //
// src/view/device/device/DeviceUpgrade.vue